import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { DEFAULT_OPTIONS } from './consts/default-options.const';
import { Options } from './interfaces/options.type';
import { NotificationComponent } from './notification/notification.component';
import { NotificationsService } from './services/notifications.service';
import { SimpleNotificationsComponent } from './simple-notifications.component';

export const OPTIONS = new InjectionToken<Options>('options');

export function optionsFactory(options: any) {
    return {
        ...DEFAULT_OPTIONS,
        ...options
    };
}

@NgModule({
    imports: [
        SimpleNotificationsComponent,
        NotificationComponent,
    ],
    exports: [SimpleNotificationsComponent]
})
export class SimpleNotificationsModule {
    static forRoot(options: Options = {}): ModuleWithProviders<SimpleNotificationsModule> {
        return {
            ngModule: SimpleNotificationsModule,
            providers: [
                NotificationsService,
                {
                    provide: OPTIONS,
                    useValue: options
                },
                {
                    provide: 'options',
                    useFactory: optionsFactory,
                    deps: [OPTIONS]
                }
            ]
        };
    }
}
